<template>
  <div class="homepage-5 dark">
    <ScrollupSection />
    <div class="main overflow-hidden">
      <HeaderSection />
      <HeroSection />
      <ServiceSection />
      <ContentOneSection />
      <ContentFourSection />
      <PricingSection />
      <ContactSection />
      <CtaSection />
      <FooterSection />
      <ModalSearchSection />
      <ModalMenuSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/Scrollup/Scrollup'
import HeaderSection from '../components/Header/Header'
import HeroSection from '../components/Hero/Hero'
import ServiceSection from '../components/Services/Service'
import ContentOneSection from '../components/Sections/SectionOne.vue'
import ContentFourSection from '../components/Sections/SectionTwo.vue'
import PricingSection from '../components/Pricing/Pricing'
import ContactSection from '../components/Contact/Contact'
import CtaSection from '../components/Cta/Cta'
import FooterSection from '../components/Footer/Footer'
import ModalSearchSection from '../components/Modal/ModalSearch/ModalSearch'
import ModalMenuSection from '../components/Modal/ModalMenu/ModalMenu'

export default {
  name: 'ThemeFive',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    ServiceSection,
    ContentOneSection,
    ContentFourSection,
    PricingSection,
    ContactSection,
    CtaSection,
    FooterSection,
    ModalSearchSection,
    ModalMenuSection
  }
}
</script>

<style>

</style>
